import actions from "./actions";

const initState = {
    getAllState: false,
    outstandingsState: false,
    outstandings: {},
    salesTrendState: false,
    salesTrend: {},
    profitLossTrendState: false,
    profitLossTrend: {},
    cashflowTrendState: false,
    cashflowTrend: {},
    cashflowForecastState: false,
    cashflowForecast: {},
    bankAccountsState: false,
    bankAccounts: {},
    salesListState: false,
    salesList: {},
    incomeBreakdownState: false,
    incomeBreakdown: {},
    expenseBreakdownState: false,
    expenseBreakdown: {},
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.DASHBOARD_ALL_REQUEST:
            return {
                ...state,
                getAllState: 'request',
                outstandingsState: 'request',
                salesTrendState: 'request',
                profitLossTrendState: 'request',
                cashflowTrendState: 'request',
                cashflowForecastState: 'request',
                bankAccountsState: 'request',
                salesListState: 'request',
                incomeBreakdownState: 'request',
                expenseBreakdownState: 'request',
            };
        case actions.DASHBOARD_ALL_SUCCESS:
            return {
                ...state,
                getAllState: 'success',
                outstandingsState: 'success',
                outstandings: action.data.outstandings,
                salesTrendState: 'success',
                salesTrend: action.data.sales_trend,
                profitLossTrendState: 'success',
                profitLossTrend: action.data.profit_loss_trend,
                cashflowTrendState: 'success',
                cashflowTrend: action.data.cashflow_trend,
                cashflowForecastState: 'success',
                cashflowForecast: action.data.cashflow_forecast,
                bankAccountsState: 'success',
                bankAccounts: action.data.bank_accounts,
                salesListState: 'success',
                salesList: action.data.sales_list,
                incomeBreakdownState: 'success',
                incomeBreakdown: action.data.income_breakdown,
                expenseBreakdownState: 'success',
                expenseBreakdown: action.data.expense_breakdown,
            };
        case actions.DASHBOARD_OUTSTANDINGS_REQUEST:
            return {
                ...state,
                outstandingsState: 'request',
            };
        case actions.DASHBOARD_OUTSTANDINGS_SUCCESS:
            return {
                ...state,
                outstandingsState: 'success',
                outstandings: action.data,
            };
        case actions.DASHBOARD_SALES_TREND_REQUEST:
            return {
                ...state,
                salesTrendState: 'request',
            };
        case actions.DASHBOARD_SALES_TREND_SUCCESS:
            return {
                ...state,
                salesTrendState: 'success',
                salesTrend: action.data,
            };
        case actions.DASHBOARD_PROFIT_LOSS_TREND_REQUEST:
            return {
                ...state,
                profitLossTrendState: 'request',
            };
        case actions.DASHBOARD_PROFIT_LOSS_TREND_SUCCESS:
            return {
                ...state,
                profitLossTrendState: 'success',
                profitLossTrend: action.data,
            };
        case actions.DASHBOARD_CASHFLOW_TREND_REQUEST:
            return {
                ...state,
                cashflowTrendState: 'request',
            };
        case actions.DASHBOARD_CASHFLOW_TREND_SUCCESS:
            return {
                ...state,
                cashflowTrendState: 'success',
                cashflowTrend: action.data,
            };
        case actions.DASHBOARD_CASHFLOW_FORECAST_REQUEST:
            return {
                ...state,
                cashflowForecastState: 'request',
            };
        case actions.DASHBOARD_CASHFLOW_FORECAST_SUCCESS:
            return {
                ...state,
                cashflowForecastState: 'success',
                cashflowForecast: action.data,
            };
        case actions.DASHBOARD_BANK_ACCOUNTS_REQUEST:
            return {
                ...state,
                bankAccountsState: 'request',
            };
        case actions.DASHBOARD_BANK_ACCOUNTS_SUCCESS:
            return {
                ...state,
                bankAccountsState: 'success',
                bankAccounts: action.data,
            };
        case actions.DASHBOARD_SALES_LIST_REQUEST:
            return {
                ...state,
                salesListState: 'request',
            };
        case actions.DASHBOARD_SALES_LIST_SUCCESS:
            return {
                ...state,
                salesListState: 'success',
                salesList: action.data,
            };
        case actions.DASHBOARD_INCOME_BREAKDOWN_REQUEST:
            return {
                ...state,
                incomeBreakdownState: 'request',
            };
        case actions.DASHBOARD_INCOME_BREAKDOWN_SUCCESS:
            return {
                ...state,
                incomeBreakdownState: 'success',
                incomeBreakdown: action.data,
            };
        case actions.DASHBOARD_EXPENSE_BREAKDOWN_REQUEST:
            return {
                ...state,
                expenseBreakdownState: 'request',
            };
        case actions.DASHBOARD_EXPENSE_BREAKDOWN_SUCCESS:
            return {
                ...state,
                expenseBreakdownState: 'success',
                expenseBreakdown: action.data,
            };
        case actions.DASHBOARD_RESET_STATE:
            return initState;
        default:
            return state;
    }
}
